import React from 'react';
import ListViewContainer from '../../Componant/JobSearch/ListView';

const ListView = () => {
  return (
    <div className='page-body'>
      <ListViewContainer />
    </div>
  );
};

export default ListView;
